import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useLocalisation } from '@3plearning/lingui-cdn';

import OneRosterManageStudents
    from '../../generic-modal/components/one-roster-manage-students/one-roster-manage-students';
import CloseButton from '../../generic-modal/components/close-button/close-button';

function EditGroupContainer({
    title,
    children,
    closeHandler,
    containerStyle,
    isOneRosterActivatedSchool
}) {
    const { i18n } = useLocalisation();
    const getOneRosterStyles = () => {
        if (isOneRosterActivatedSchool) {
            return ({
                padding: '20px 24px',
                border: '2px solid #f7d064',
                borderRadius: '16px'
            });
        }
        return null;
    };

    return (
        <div
            style={{ ...containerStyle, ...getOneRosterStyles() }}
            className="edit-group-container"
        >
            {
                isOneRosterActivatedSchool ?
                    <OneRosterManageStudents i18n={i18n} title={title} />
                    :
                    <Fragment>
                        <div className="modal__header">
                            <h2 className="modal__title modal__edit-groups">{title}</h2>
                            <CloseButton closeHandler={closeHandler} i18n={i18n} />
                        </div>
                        {children}
                    </Fragment>
            }
        </div>
    );
}

EditGroupContainer.propTypes = {
    title: PropTypes.object,
    children: PropTypes.any,
    closeHandler: PropTypes.func.isRequired,
    containerStyle: PropTypes.object,
    isOneRosterActivatedSchool: PropTypes.bool
};

export default EditGroupContainer;



// WEBPACK FOOTER //
// ./components/groups/group-modals/edit-group-modal.js